import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {FieldRequestParameters, RequestParameters} from '../../models/request-parameters/parameter.model';
import {CountryService} from '../../../parameters/countries/country.service';
import {Country} from '../../../parameters/countries/country.model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-countries-autocomplete',
  templateUrl: './countries-autocomplete.component.html',
  styleUrls: ['./countries-autocomplete.component.scss']
})
export class CountriesAutocompleteComponent implements OnInit {

  @Input('countryFormControl') countryFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Input('countryCode') countryCode: string;
  @Output() onCountrySelected: EventEmitter<Country> = new EventEmitter<Country>();

  @ViewChild('autoCountries') autoCountries: ElementRef;

  countries: Observable<any> = new Observable<any>();
  countryLoading: boolean = true;
  countryParameters: RequestParameters = new RequestParameters();

  constructor(private countryService: CountryService) {
  }

  ngOnInit() {
    if (this.countryCode) {
      this.countryParameters.fields.push(new FieldRequestParameters('countryCode', this.countryCode));
      this.countryParameters.limit = 200;
    }
    this.updateCountries();
  }

  onSelectCountry() {
    this.onCountrySelected.emit(this.countryFormControl.value);
  }

  displayCountries (country: Country) {
    if (country !== null) {
      return country.name;
    }
  }

  filterCountries (filterInput: string = '') {
    if (this.countryParameters.searchString !== filterInput) {
      this.countryParameters.searchString = filterInput;
      this.updateCountries();
    }
  }

  restrictCountries(countries: Country[]): Country[] {
    if (!this.countryCode || !countries) {
      return countries;
    }
    const code = this.countryCode.toUpperCase();
    return countries.filter((country) => {
      if (!country) {
        return false;
      }
      if (country.countryCode && country.countryCode.toUpperCase() === code) {
        return true;
      }
      return code === 'BJ' && !!country.name && /b[eé]nin/i.test(country.name);
    });
  }

  updateCountries () {
    this.countryLoading = true;
    this.countries = this.countryService.getCountries(this.countryParameters)
      .map(
        (response) => {
          this.countryLoading = false;
          return this.restrictCountries(response.result);
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/countries-autocomplete/countries-autocomplete.component.ts